<template>
  <div>{{ formatValue }}</div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import dict from './dict-mixin-extend'

export default {
  mixins: [dict],
  props: {
    dictCode: {
      type: String,
      default: undefined
    },
    value: {
      type: [String, Number],
      default: undefined
    },
    // 字典查不到文案时的兜底文案（不传则维持原行为，显示空白）
    fallbackText: {
      type: String,
      default: ''
    }
  },
  computed: {
    formatValue() {
      console.log('approvalTaskStatus审批任务状态是啥---->', this.dictCode, this.value)
      const name = this.getDictItemName(this.dictCode, this.value)
      return (name === undefined || name === null || name === '') ? this.fallbackText : name
    }
  }
  // render (createElement) {
  //     this.$slots.default.forEach(item => {
  //         item.text = this.getDictItemName(this.dictCode, item.text, fieldKey)
  //     })
  //     return createElement(
  //         'div',
  //         [this.$slots['default']]
  //     )
  // }
}
</script>